import React, { useEffect, useRef, useState } from "react";
import "../styles/SignUpStatement.css";

import PersonIcon from "../icons/SignInIcon/PersonIcon";
import LockIcon from "../icons/SignInIcon/Lockicon";
import EyeView from "../icons/SignInIcon/EyeView";
import ShowIcon from "../icons/SignInIcon/ShowIcon";
import Utils from "../utils/Utils";
import SignInVerification from "../components/SignInVerification.js";
import { useNavigate } from "react-router-dom";
import userController from "../controllers/userController";
import EmployeeController from "../controllers/EmployeeController.js";
import { EncryptStorage } from "encrypt-storage";
import { toast } from "react-toastify";
import CloseIcon from "../icons/SignInIcon/closeIcon.js";
import AzaleaLogo from "../icons/SignInIcon/AzaleaLogo.js";
import EmailIcon from "../icons/SignInIcon/EmailIcon.js";
import GloablButton from "./GloablButton.js";
import LockIconBleu from "../icons/SignInIcon/LockIconBleu.js";
import DoneIcone from "../icons/SignInIcon/doneIcon.js";
import companyController from "../controllers/companyController.js";
import { userService } from "../services/userService.js";
import SingleDatePicker from "./SingleDatePicker.js";
import XIcon from "../icons/XIcon.js";
function SignInInput({ onhidesignupdiv }) {
  const encryptStorage1 = new EncryptStorage("secret-key", {
    prefix: "@instance1",
  });
  const encryptStorage2 = new EncryptStorage("secret-key1", {
    prefix: "@instance2",
  });
  const encryptStorage3 = new EncryptStorage("secret-key3", {
    prefix: "@instance3",
  });
  const encryptStorage4 = new EncryptStorage("secret-key4", {
    prefix: "@instance4",
  });
  const encryptStorage5 = new EncryptStorage("secret-key5", {
    prefix: "@instance5",
  });
  const navigate = useNavigate();

  const [openOtpPopup, setOpenOtpPopup] = useState(false);
  const [openOtpDonePopup, setOpenOtpDonePopup] = useState(false);
  const [openUpiRecoveredPopup, setOpenUpiRecoveredPopup] = useState(false);
  const [forgetpass, setforgetpass] = useState(false);
  const [forgotPasswordStep, setForgotPasswordStep] = useState(1);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotPasswordOtp, setForgotPasswordOtp] = useState("");
  const [forgotOtpLoading, setForgotOtpLoading] = useState(false);
  const [forgotOtpError, setForgotOtpError] = useState("");
  const [resetNewPassword, setResetNewPassword] = useState("");
  const [resetConfirmPassword, setResetConfirmPassword] = useState("");
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false);
  const [resetPasswordError, setResetPasswordError] = useState("");
  const [isForgotEmailValid, setIsForgotEmailValid] = useState(true);
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [birthdate, setBirthdate] = useState(null);

  const [jwt, setJwt] = useState(null);
  const [upivalue, setUPIValue] = useState("");
  const [showsignindiv, setShowSinInDiv] = useState(true);

  const [rememberupi, setRememberUpi] = useState(false);
  const [rememberpass, setRememberPass] = useState(false);

  const [isValidEmail, setIsValidEmail] = useState(true);
  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [openUPIPopup, setOpenUPIPopup] = useState(false);
  const openUPIPopupHandler = () => setOpenUPIPopup(true);
  const closeUPIPopup = () => setOpenUPIPopup(false);
  const closeOtpPopup = () => setOpenOtpPopup(false);
  const closeOtpDonePopup = () => setOpenOtpDonePopup(false);
  const closeUpiRecoveredPopup = () => setOpenUpiRecoveredPopup(false);

  const handleBackToLogin = () => {
    setOpenUpiRecoveredPopup(false);
    setShowSinInDiv(true);
    setOpenUPIPopup(false);
    setOpenOtpPopup(false);
    setOpenOtpDonePopup(false);
    setOtp(["", "", "", "", "", ""]);
    setSelectedCompany("");
    setBirthdate("");
  };

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const otpRefs = useRef([]);

  const [resendSeconds, setResendSeconds] = useState(60);

  useEffect(() => {
    if (!openOtpPopup) return;

    setOtp(["", "", "", "", "", ""]);
    setResendSeconds(60);

    setTimeout(() => otpRefs.current[0]?.focus(), 0);

    const t = setInterval(() => {
      setResendSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);

    return () => clearInterval(t);
  }, [openOtpPopup]);

  const formatTime = (s) => {
    const mm = String(Math.floor(s / 60)).padStart(2, "0");
    const ss = String(s % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const handleOtpChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    const next = [...otp];
    next[index] = digit;
    setOtp(next);

    if (digit && index < 5) otpRefs.current[index + 1]?.focus();
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const next = [...otp];
        next[index] = "";
        setOtp(next);
      } else if (index > 0) {
        otpRefs.current[index - 1]?.focus();
        const next = [...otp];
        next[index - 1] = "";
        setOtp(next);
      }
    }

    if (e.key === "ArrowLeft" && index > 0) otpRefs.current[index - 1]?.focus();
    if (e.key === "ArrowRight" && index < 5)
      otpRefs.current[index + 1]?.focus();
  };

  const handleOtpPaste = (e) => {
    const text = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!text) return;

    const next = ["", "", "", "", "", ""];
    for (let i = 0; i < text.length; i++) next[i] = text[i];
    setOtp(next);

    const focusIndex = Math.min(text.length, 6) - 1;
    if (focusIndex >= 0) otpRefs.current[focusIndex]?.focus();
  };

  // const saveUserDTO = (emailVal, passwordVal, upiVal) => {
  //   const existingUser = encryptStorage1.getItem("user") ?? {
  //     credentials: { email: null, password: null },
  //     upi: null,
  //   };

  //   if (emailVal != null && passwordVal != null) {
  //     existingUser.credentials = { email: emailVal, password: passwordVal };
  //   }

  //   if (upiVal != null) {
  //     existingUser.upi = upiVal;
  //   }

  //   encryptStorage1.setItem("user", existingUser);
  // };
  // const dataToSave = [];
  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");
    setUPIValue(digitsOnly);
  };

  const togglePassword = () => setShowPassword(!showPassword);

  const handlePass = (event) => setRememberPass(event.target.checked);
  const handleUpi = (event) => setRememberUpi(event.target.checked);

  const onSignInClick = () => {
    try {
      const isValidEmail2 = Utils.checkEmailFormat(email);
      setIsValidEmail(isValidEmail2);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSignInClick = async () => {
    onSignInClick();

    try {
      const isValidEmail2 = Utils.checkEmailFormat(email);
      setIsValidEmail(isValidEmail2);
      if (!isValidEmail2) return;

      const authenticationRequest = {
        username: email,
        password: password,
      };

      const res = await userController.authenticateUser({
        authenticationDTO: authenticationRequest,
      });
      if (res.status == "net::ERR_TIMED_OUT") {
        toast.error(res, "System Time Out");
      }
      if (res?.status === 200 && res?.data?.jwt) {
        const jwtToken = res.data.jwt;

        const parsed = Utils.parseJwt(jwtToken);
        encryptStorage3.setItem(
          "user-azalea",
          Object.keys(parsed.userDetails)[0],
        );
        setJwt(jwtToken);
        const getPrimaryComp = async () => {
          if (!jwtToken) return;
          const userId = Utils.getUserIdFromJwt(parsed);
          if (!userId) return;
          const res = await companyController.userPrimaryCompanies({
            Authorization: jwtToken,
            userId,
          });

          const primaryCompanyID = res?.data?.[0]?.companyID;
          if (primaryCompanyID) {
            encryptStorage3.setItem("user-azalea", primaryCompanyID);
          }
          encryptStorage3.setItem("user-azalea", primaryCompanyID);

          const found = res?.data?.find(
            (c) => String(c.companyID) === String(primaryCompanyID),
          );

          encryptStorage4.setItem("user-azalea", found.businessProfileID);

          // if businessProfileID is on the company object, this is safe now
          // if (found?.businessProfileID != null) {
          //   encryptStorage4.setItem("user-azalea", found.businessProfileID);
          // } else {
          //   // optionally remove or set null to avoid stale value
          //   // encryptStorage4.removeItem("user-azalea");
          // }
        };
        getPrimaryComp();

        const enrollmultiA = { email: email, upi: upivalue };

        if (
          !Object.values(Utils.parseJwt(jwtToken).userDetails)
            .map((u) => String(u.upi))
            .includes(String(upivalue))
        ) {
          toast.error("Entered UPI does not match this account");
          return;
        }

        const enrollMfaRes = await userController.enrollMfa({
          mfaDTO: enrollmultiA,
          jwt: jwtToken,
        });

        try {
          /************************************** */
          const msg = String(enrollMfaRes?.data?.message);

          const notEnforced = msg.toLowerCase().includes("mfa not enforced");

          if (Utils.isSuccessResponse(enrollMfaRes) && notEnforced) {
            toast.success(msg || "MFA NOT Enforced");
            encryptStorage1.setItem("user-azalea", res.data.jwt);
            const dataToSave = {
              username: rememberpass ? email : null,
              password: rememberpass ? password : null,
              rememberpass: rememberpass,
            };
            const dataToSaved = {
              upi: rememberupi ? upivalue : null,
              rememberupi: rememberupi,
            };
            encryptStorage5.setItem("user-upi", dataToSaved);
            encryptStorage2.setItem("user-data", dataToSave);
            navigate("/user-management");
            return;
          }
          /*********************************************** */
          if (
            Utils.isSuccessResponse(enrollMfaRes) &&
            enrollMfaRes?.data?.qrCodeBase64 !== null
          ) {
            toast.success(enrollMfaRes.data.message);
            const dataToSave = {
              username: rememberpass ? email : null,
              password: rememberpass ? password : null,
              rememberpass: rememberpass,
            };
            const dataToSaved = {
              upi: rememberupi ? upivalue : null,
              rememberupi: rememberupi,
            };
            encryptStorage5.setItem("user-upi", dataToSaved);
            encryptStorage1.setItem("user-azalea", res.data.jwt);
            encryptStorage2.setItem("user-data", dataToSave);
            const qrModal = document.getElementById("qrModal");
            const qrContainer = document.getElementById("qrCodeContainer");

            qrContainer.innerHTML = "";
            const img = document.createElement("img");
            img.src = `data:image/png;base64,${enrollMfaRes.data.qrCodeBase64}`;
            img.alt = "MFA QR Code";
            img.style.width = "200px";
            img.style.height = "200px";
            qrContainer.appendChild(img);

            qrModal.style.display = "flex";

            const closeModalBtn = document.getElementById("closeModalBtn");
            closeModalBtn.onclick = () => {
              qrModal.style.display = "none";
            };
            return;
          } else if (
            Utils.isSuccessResponse(enrollMfaRes) &&
            enrollMfaRes?.data?.qrCodeBase64 == null
          ) {
            const dataToSave = {
              username: rememberpass ? email : null,
              password: rememberpass ? password : null,
              rememberpass: rememberpass,
            };
            const dataToSaved = {
              upi: rememberupi ? upivalue : null,
              rememberupi: rememberupi,
            };
            if (rememberupi) encryptStorage5.setItem("user-upi", dataToSaved);
            else if (!rememberupi) encryptStorage5.removeItem("user-upi");
            encryptStorage1.setItem("user-azalea", jwt);
            if (rememberpass) encryptStorage2.setItem("user-data", dataToSave);
            else if (!rememberpass) encryptStorage2.removeItem("user-data");
            setShowSinInDiv(false);

            return;
          } else {
            toast.error(enrollMfaRes?.data?.message || "Error");
          }
        } catch (err) {
          toast.error(enrollMfaRes?.response?.data?.message || "Error");
        }
      } else {
        toast.error("Invalid User name or password");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSignInSubmit = async (event) => {
    event.preventDefault();
    await handleSignInClick();
  };
  /******************************************* */
  useEffect(() => {
    const userData = userService.getUserObject();
    const userupi = userService.getupidata();
    if (userData) {
      setRememberPass(userData?.rememberpass);
      setRememberUpi(userupi?.rememberupi);
      setUPIValue(userupi?.upi);
      setEmail(userData?.username);
      setPassword(userData?.password);
    }
  }, []);
  /******************************************* */
  // useEffect(() => {
  //   const user = encryptStorage1.getItem("user");
  //   if (!user) return;

  //   if (user.credentials?.email && user.credentials?.password) {
  //     setEmail(user.credentials.email);
  //     setPassword(user.credentials.password);
  //     setRememberPass(true);
  //   }

  //   if (user.upi) {
  //     setUPIValue(user.upi);
  //     setRememberUpi(true);
  //   }
  // }, []);
  const openForgotPassword = () => {
    setForgotPasswordStep(1);
    setForgotEmail(email);
    setForgotPasswordOtp("");
    setForgotOtpError("");
    setResetNewPassword("");
    setResetConfirmPassword("");
    setResetPasswordError("");
    setIsForgotEmailValid(true);
    setforgetpass(true);
  };
  const closeForgotPassword = () => {
    setforgetpass(false);
    setForgotPasswordStep(1);
    setForgotPasswordOtp("");
    setForgotOtpError("");
    setResetNewPassword("");
    setResetConfirmPassword("");
    setResetPasswordError("");
    setIsForgotEmailValid(true);
  };
  const handleForgotPassword = async (event) => {
    event.preventDefault();

    const normalizedEmail = forgotEmail.trim().toLowerCase();
    const emailIsValid = Utils.checkEmailFormat(normalizedEmail);
    setIsForgotEmailValid(emailIsValid);

    if (!emailIsValid || forgotPasswordLoading) return;

    try {
      setForgotPasswordLoading(true);
      const res = await userController.forgetpassword({
        source: "EMAIL",
        value: normalizedEmail,
      });

      if (Utils.isSuccessResponse(res) && res?.data.sent === true) {
        setForgotPasswordStep(2);
        toast.success("A verification code was sent to your email.", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        const responseData = getResponseData(res);
        toast.error(
          responseData?.message ||
            "We could not send a verification code. Please try again.",
          {
            position: "top-right",
            autoClose: 3000,
          },
        );
      }
    } catch {
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setForgotPasswordLoading(false);
    }
  };
  const handleSendVerification = async () => {
    if (!email) {
      toast.error("Please enter email");
      return;
    }

    try {
      const otpEmailSubject = "Azalea Verification Code";

      const res = await userController.sendEmailOtp({
        email,
        otpEmailSubject,
      });

      if (Utils.isSuccessResponse(res)) {
        setOpenUPIPopup(false);
        setOpenOtpPopup(true);

        setOtp(["", "", "", "", "", ""]);
        setResendSeconds(60);
        setTimeout(() => otpRefs.current[0]?.focus(), 0);

        toast.success(res?.data?.message || "Verification sent");
      } else {
        toast.error(res?.data?.message || "Failed to send OTP");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };

  const handleResendOtp = async () => {
    if (resendSeconds > 0) return;
    await handleSendVerification();
  };

  const handleVerifyOtpContinue = async () => {
    const cleanedOtp = otp.join("").replace(/\D/g, "").slice(0, 6);

    if (cleanedOtp.length !== 6) {
      toast.error("Please enter the 6-digit code");
      return;
    }

    try {
      const verifyOtpDTO = { email: email, otp: cleanedOtp };
      const res = await userController.verifyEmailOtp({ verifyOtpDTO });

      const okStatus = Utils.isSuccessResponse(res);
      const msg = res?.data?.message;

      const isVerified =
        okStatus &&
        (msg === "OTP Verified" || msg === "Verified" || res?.data === true);

      if (isVerified) {
        toast.success(msg || "OTP Verified");
        setOpenOtpPopup(false);
        setOpenOtpDonePopup(true);
      } else {
        toast.error(msg || "Invalid code");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Invalid code");
    }
  };

  useEffect(() => {
    if (!openOtpDonePopup) return;
    if (!email) return;

    const fetchCompanies = async () => {
      try {
        setCompaniesLoading(true);

        const res = await EmployeeController.getEmployeeCompanies({ email });

        if (res?.status === 200) {
          const data = res?.data;
          const list = data?.companies || data?.data || data || [];
          const normalized = Array.isArray(list) ? list : [];

          setCompanies(normalized);
          setSelectedCompany("");
          setBirthdate("");

          if (normalized.length === 0) {
            toast.info("No companies found for this email");
          }
        } else {
          toast.error(res?.data?.message || "Failed to load companies");
          setCompanies([]);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Failed to load companies");
        setCompanies([]);
      } finally {
        setCompaniesLoading(false);
      }
    };

    fetchCompanies();
  }, [openOtpDonePopup, email]);

  const formatBirthdateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";

    const [dd, mm, yyyy] = dateStr.split("/");

    if (!dd || !mm || !yyyy) return "";

    return `${dd}-${mm}-${yyyy}`;
  };

  const handleOtpDoneContinue = async () => {
    if (!selectedCompany) {
      toast.error("Please select a company");
      return;
    }
    if (!birthdate) {
      toast.error("Please enter birthdate");
      return;
    }

    const forgetUpiRequest = {
      birthday: formatBirthdateToDDMMYYYY(birthdate),
      userCompanyID: selectedCompany,
    };

    try {
      const res = await EmployeeController.forgetEmployeeUPI({
        forgetUpiRequest: forgetUpiRequest,
      });

      if (Utils.isSuccessResponse(res)) {
        toast.success(res?.data?.message || "UPI recovered successfully");
        setOpenOtpDonePopup(false);
        setOpenUpiRecoveredPopup(true);
      } else {
        toast.error(res?.data?.message || "Failed to recover UPI");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to recover UPI");
    }
  };
  const verifyOTP = async () => {
    if (forgotPasswordOtp.length !== 6 || forgotOtpLoading) return;

    try {
      setForgotOtpLoading(true);
      setForgotOtpError("");

      const verifyResponse = await userController.verifyEmailOtp({
        verifyOtpDTO: {
          email: forgotEmail.trim().toLowerCase(),
          otp: forgotPasswordOtp,
        },
      });
      const responseData = getResponseData(verifyResponse);

      if (responseData?.message === "OTP Verified") {
        setForgotPasswordStep(3);
        return;
      }

      setForgotOtpError(
        responseData?.message || "The verification code is incorrect.",
      );
    } catch (error) {
      setForgotOtpError(
        error?.response?.data?.message ||
          "Verification failed. Please try again.",
      );
    } finally {
      setForgotOtpLoading(false);
    }
  };

  const handleSetForgottenPassword = async (event) => {
    event.preventDefault();

    const passwordRulesAreValid =
      resetNewPassword.length >= 8 &&
      /[A-Z]/.test(resetNewPassword) &&
      /[a-z]/.test(resetNewPassword) &&
      /\d/.test(resetNewPassword) &&
      /[^A-Za-z0-9]/.test(resetNewPassword);

    if (!passwordRulesAreValid) {
      setResetPasswordError(
        "Use at least 8 characters with uppercase, lowercase, number, and special character.",
      );
      return;
    }

    if (resetNewPassword !== resetConfirmPassword) {
      setResetPasswordError("The passwords do not match.");
      return;
    }

    if (resetPasswordLoading) return;

    try {
      setResetPasswordLoading(true);
      setResetPasswordError("");

      const setPasswordResponse = await userController.setPassword({
        setPasswordDTO: {
          emailOrPhone: forgotEmail.trim().toLowerCase(),
          newPassword: resetNewPassword,
          confirmPassword: resetConfirmPassword,
          otp: forgotPasswordOtp,
        },
      });

      if (Utils.isSuccessResponse(setPasswordResponse)) {
        setEmail(forgotEmail.trim().toLowerCase());
        toast.success("Your password has been reset. You can now sign in.", {
          position: "top-right",
          autoClose: 3000,
        });
        closeForgotPassword();
        return;
      }

      const responseData = getResponseData(setPasswordResponse);
      setResetPasswordError(
        responseData?.message || "Could not reset your password.",
      );
    } catch (error) {
      setResetPasswordError(
        error?.response?.data?.message ||
          "Could not reset your password. Please try again.",
      );
    } finally {
      setResetPasswordLoading(false);
    }
  };
  const getResponseData = (response) => {
    const data = response?.data || response?.response?.data || {};

    if (typeof data === "string") {
      try {
        return Utils.AESDecrypt(data);
      } catch {
        return data;
      }
    }

    return data;
  };
  return (
    <div className="signin-main-parent-container">
      {forgetpass ? (
        <div
          className="forget-pass-popup-layer"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) closeForgotPassword();
          }}
        >
          <section
            className="forget-pass-popup"
            role="dialog"
            aria-modal="true"
            aria-labelledby="forget-pass-title"
          >
            <button
              className="forget-pass-close"
              type="button"
              aria-label="Close reset password dialog"
              onClick={closeForgotPassword}
            >
              <XIcon stroke="#667085" />
            </button>

            <div
              className="forget-pass-stepper"
              aria-label={`Step ${forgotPasswordStep} of 3`}
            >
              <span
                className={`forget-pass-step ${
                  forgotPasswordStep === 1 ? "is-active" : "is-complete"
                }`}
              >
                {forgotPasswordStep > 1 ? "✓" : "1"}
              </span>
              <span
                className={`forget-pass-step-line ${
                  forgotPasswordStep > 1 ? "is-complete" : ""
                }`}
              />
              <span
                className={`forget-pass-step ${
                  forgotPasswordStep === 2
                    ? "is-active"
                    : forgotPasswordStep > 2
                      ? "is-complete"
                      : ""
                }`}
              >
                {forgotPasswordStep > 2 ? "✓" : "2"}
              </span>
              <span
                className={`forget-pass-step-line ${
                  forgotPasswordStep > 2 ? "is-complete" : ""
                }`}
              />
              <span
                className={`forget-pass-step ${
                  forgotPasswordStep === 3 ? "is-active" : ""
                }`}
              >
                3
              </span>
            </div>

            {forgotPasswordStep === 1 ? (
              <>
                <div className="forget-pass-heading">
                  <div className="forget-pass-icon" aria-hidden="true">
                    <LockIcon />
                  </div>
                  <h2 id="forget-pass-title">Forgot your password?</h2>
                  <p>
                    No worries. Enter the email address linked to your account
                    and we’ll send you a verification code.
                  </p>
                </div>

                <form
                  className="forget-pass-form"
                  onSubmit={handleForgotPassword}
                >
                  <label htmlFor="forgot-password-email">
                    Email address <span>*</span>
                  </label>
                  <div
                    className={`forget-pass-email-field ${
                      isForgotEmailValid ? "" : "has-error"
                    }`}
                  >
                    <span className="forget-pass-email-icon" aria-hidden="true">
                      @
                    </span>
                    <input
                      id="forgot-password-email"
                      type="email"
                      autoComplete="email"
                      autoFocus
                      value={forgotEmail}
                      placeholder="Enter your email address"
                      aria-invalid={!isForgotEmailValid}
                      aria-describedby={
                        isForgotEmailValid ? undefined : "forgot-email-error"
                      }
                      onChange={(event) => {
                        setForgotEmail(event.target.value);
                        if (!isForgotEmailValid) setIsForgotEmailValid(true);
                      }}
                    />
                  </div>
                  {!isForgotEmailValid && (
                    <div className="forget-pass-error" id="forgot-email-error">
                      Please enter a valid email address
                    </div>
                  )}

                  <button
                    className="forget-pass-submit"
                    type="submit"
                    disabled={forgotPasswordLoading}
                  >
                    {forgotPasswordLoading
                      ? "Sending code..."
                      : "Send verification code"}
                  </button>
                  <button
                    className="forget-pass-back"
                    type="button"
                    onClick={closeForgotPassword}
                  >
                    <span aria-hidden="true">←</span> Back to sign in
                  </button>
                </form>
              </>
            ) : forgotPasswordStep === 2 ? (
              <>
                <div className="forget-pass-heading">
                  <div className="forget-pass-icon" aria-hidden="true">
                    <LockIcon />
                  </div>
                  <h2 id="forget-pass-title">Check your email</h2>
                  <p>
                    We sent a 6-digit verification code to{" "}
                    <strong>{forgotEmail.trim().toLowerCase()}</strong>
                  </p>
                </div>

                <form
                  className="forget-pass-form"
                  onSubmit={(event) => event.preventDefault()}
                >
                  <label htmlFor="forgot-password-otp">
                    Verification code <span>*</span>
                  </label>
                  <input
                    id="forgot-password-otp"
                    className="forget-pass-otp-input"
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    autoFocus
                    maxLength="6"
                    value={forgotPasswordOtp}
                    placeholder="000000"
                    onChange={(event) => {
                      setForgotPasswordOtp(
                        event.target.value.replace(/\D/g, "").slice(0, 6),
                      );
                      setForgotOtpError("");
                    }}
                  />
                  {forgotOtpError && (
                    <div className="forget-pass-error">{forgotOtpError}</div>
                  )}
                  <button
                    className="forget-pass-submit"
                    type="submit"
                    disabled={
                      forgotPasswordOtp.length !== 6 || forgotOtpLoading
                    }
                    onClick={() => verifyOTP()}
                  >
                    {forgotOtpLoading ? "Verifying..." : "Verify code"}
                  </button>
                  <button
                    className="forget-pass-back"
                    type="button"
                    onClick={() => {
                      setForgotPasswordStep(1);
                      setForgotPasswordOtp("");
                    }}
                  >
                    <span aria-hidden="true">←</span> Change email address
                  </button>
                </form>
              </>
            ) : (
              <>
                <div className="forget-pass-heading">
                  <div className="forget-pass-icon" aria-hidden="true">
                    <LockIcon />
                  </div>
                  <h2 id="forget-pass-title">Create a new password</h2>
                  <p>
                    Choose a strong password you havenâ€™t used for this account
                    before.
                  </p>
                </div>

                <form
                  className="forget-pass-form"
                  onSubmit={handleSetForgottenPassword}
                >
                  <label htmlFor="reset-new-password">
                    New password <span>*</span>
                  </label>
                  <div className="forget-pass-password-field">
                    <input
                      id="reset-new-password"
                      className="forget-pass-password-input"
                      type={showPassword ? "text" : "password"}
                      autoComplete="new-password"
                      autoFocus
                      value={resetNewPassword}
                      placeholder="Enter your new password"
                      onChange={(event) => {
                        setResetNewPassword(event.target.value);
                        setResetPasswordError("");
                      }}
                    />
                    <button
                      className="forget-pass-password-toggle"
                      type="button"
                      onClick={togglePassword}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? <ShowIcon /> : <EyeView />}
                    </button>
                  </div>

                  <label
                    className="forget-pass-confirm-label"
                    htmlFor="reset-confirm-password"
                  >
                    Confirm new password <span>*</span>
                  </label>
                  <div className="forget-pass-password-field">
                    <input
                      id="reset-confirm-password"
                      className="forget-pass-password-input"
                      type="password"
                      autoComplete="new-password"
                      value={resetConfirmPassword}
                      placeholder="Confirm your new password"
                      onChange={(event) => {
                        setResetConfirmPassword(event.target.value);
                        setResetPasswordError("");
                      }}
                    />
                    {/* <button
                      className="forget-pass-password-toggle"
                      type="button"
                      onClick={togglePassword}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? <ShowIcon /> : <EyeView />}
                    </button> */}
                  </div>

                  <div className="forget-pass-password-hint">
                    At least 8 characters with uppercase, lowercase, number, and
                    special character.
                  </div>
                  {resetPasswordError && (
                    <div className="forget-pass-error">
                      {resetPasswordError}
                    </div>
                  )}

                  <button
                    className="forget-pass-submit"
                    type="submit"
                    disabled={
                      !resetNewPassword ||
                      !resetConfirmPassword ||
                      resetPasswordLoading
                    }
                  >
                    {resetPasswordLoading
                      ? "Resetting password..."
                      : "Reset password"}
                  </button>
                  <button
                    className="forget-pass-back"
                    type="button"
                    onClick={() => {
                      setForgotPasswordStep(2);
                      setResetPasswordError("");
                    }}
                  >
                    <span aria-hidden="true">←</span> Back to verification
                  </button>
                </form>
              </>
            )}
          </section>
        </div>
      ) : null}
      {showsignindiv ? (
        <form
          className="signin-window-main-container"
          onSubmit={handleSignInSubmit}
        >
          <div className="signin-window-main-container-title">
            <div className="signin-window-title-text">Sign In</div>
          </div>

          <div className="singin-window-data-in-container">
            <div className="signin-window-data-in-upi">
              <div className="signin-window-data-in-title-upi">
                UPI <div className="required">*</div>
                <div className="dont-have-acc">(Don’t have?)</div>
              </div>

              <div className="signin-window-data-in-normal-box">
                <div className="signin-window-data-in-username-container">
                  <div className="signin-window-data-in-person-icon">
                    <PersonIcon />
                  </div>

                  <input
                    className="signin-window-data-in-text"
                    type="text"
                    value={upivalue}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="upi-footer">
                <div className="signin-window-remember-upi">
                  <input
                    className="signin-window-datain-remember-checkbox"
                    type="checkbox"
                    checked={rememberupi}
                    onChange={handleUpi}
                  />
                  <div className="remember-me-upi">Remember this account</div>
                </div>

                <div
                  className="signin-window-forgetupi"
                  onClick={openUPIPopupHandler}
                  role="button"
                  tabIndex={0}
                >
                  Forget UPI?
                </div>
              </div>
            </div>

            <div className="signin-window-data-in">
              <div className="signin-window-data-in-title">
                Username<div className="required">*</div>
              </div>

              <div className="signin-window-data-in-normal-box">
                <div className="signin-window-data-in-username-container">
                  <div className="signin-window-data-in-person-icon">
                    <PersonIcon />
                  </div>

                  <input
                    type="email"
                    name="email"
                    // defaultValue={savedEmailFromStorage || ""}
                    className="signin-window-data-in-text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                  />
                </div>
              </div>

              <div
                className="rong-email"
                style={{ display: isValidEmail ? "none" : "flex" }}
              >
                Please enter a valid email address
              </div>
            </div>

            <div className="signin-window-data-in-password-container">
              <div className="signin-window-data-in-title">
                Password <div className="required">*</div>
              </div>

              <div className="signin-window-data-in-password">
                <div className="signin-window-data-in-password-text">
                  <div className="signin-password-icon">
                    <LockIcon />
                  </div>

                  <input
                    className="signin-window-password-input"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder=""
                  />
                </div>

                <div className="eye-view-content">
                  <div className="eye-icon" onClick={togglePassword}>
                    {showPassword ? <ShowIcon /> : <EyeView />}
                  </div>
                </div>
              </div>

              <div className="signin-window-footer">
                <div className="signin-window-remember-main-container">
                  <div className="signin-window-footer-remember">
                    <input
                      className="signin-window-datain-footer-remember-checkbox"
                      type="checkbox"
                      checked={rememberpass}
                      onChange={handlePass}
                    />
                    <div>Remember password</div>
                  </div>
                </div>

                <div
                  className="signin-window-forgetpass"
                  onClick={openForgotPassword}
                >
                  Forget Password?
                </div>
              </div>
            </div>
          </div>

          <button className="signin-action-bottom-enduser" type="submit">
            Sign In
          </button>

          <div
            className="root-signin-action-bottom"
            onClick={() => navigate("/SignInRootUser")}
          >
            Sign in using root user email
          </div>

          <div className="dont-have-acc-container-responsive">
            <div className="dont-have-acc-container-text-responsive">
              Don’t have an account?
            </div>
            <div
              className="dont-have-acc-container-link-responsive"
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_DEV_ENVIROMET_URL}/register`,
                  "_blank",
                );
              }}
            >
              Sign UP
            </div>
          </div>

          <div className="terms-and-conditions">
            <div className="terms-and-conditions-text">
              By creating an account, you agree to Azalea’s{" "}
              <div className="terms-of-use">Terms of Use</div> and{" "}
              <div className="privacy-policy">Privacy Policy</div>.
            </div>
          </div>

          <div
            className="qrModel"
            id="qrModal"
            style={{
              display: "none",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <h3>MFA QR Code</h3>
              <div className="qr-code-container" id="qrCodeContainer"></div>

              <button
                type="button"
                onClick={() => setShowSinInDiv(false)}
                id="closeModalBtn"
              >
                Close
              </button>
            </div>
          </div>
        </form>
      ) : (
        <SignInVerification
          rememberpass={rememberpass}
          rememberupi={rememberupi}
          upivalue={upivalue}
          jwt={jwt}
          username={email}
          password={password}
        />
      )}

      {openUPIPopup && (
        <div className="upi-popup-overlay" onClick={closeUPIPopup}>
          <div className="upi-popup" onClick={(e) => e.stopPropagation()}>
            <div className="close-icon" onClick={closeUPIPopup}>
              <CloseIcon />
            </div>

            <div className="upi-forget-popup-picture">
              <AzaleaLogo />
            </div>

            <div className="upi-forget-popup-section">
              <div className="upi-forget-popup-title">Recover your UPI</div>
              <div className="upi-forget-popup-paragraphe">
                Enter the email linked to your account.
              </div>
            </div>

            <div className="upi-forget-field">
              <div className="upi-forget-email">
                Email Address <span>*</span>
              </div>

              <div className="upi-input-wrap">
                <span className="upi-input-icon">
                  <EmailIcon />
                </span>

                <input
                  className="upi-input"
                  type="email"
                  placeholder=""
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="upi-forget-popup-action">
              <div className="upi-send-btn" type="button">
                <GloablButton
                  width="250px"
                  height="44px"
                  backgroundColor="#4072C8"
                  text="Send Verification Code"
                  borderRadius="50px"
                  onClick={handleSendVerification}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {openOtpPopup && (
        <div className="upi-popup-overlay" onClick={closeOtpPopup}>
          <div className="upi-popup" onClick={(e) => e.stopPropagation()}>
            <div className="close-icon" onClick={closeOtpPopup}>
              <CloseIcon />
            </div>

            <div className="upi-forget-popup-picture">
              <LockIconBleu />
            </div>

            <div className="upi-forget-popup-section">
              <div className="upi-forget-popup-title">Verification Code</div>
              <div className="upi-forget-popup-paragraphe">
                We have sent a verification code to {email || "your email"}
              </div>
            </div>

            <div className="upi-forget-field otp-field">
              <div className="upi-otp-email-text">Enter OTP code</div>

              <div className="upi-otp-boxes" onPaste={handleOtpPaste}>
                {otp.map((digit, i) => (
                  <input
                    key={i}
                    ref={(el) => (otpRefs.current[i] = el)}
                    className="upi-otp-box"
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(i, e.target.value)}
                    onKeyDown={(e) => handleOtpKeyDown(i, e)}
                    autoFocus={i === 0}
                  />
                ))}
              </div>

              <div className="upi-otp-footer">
                <div className="upi-otp-footer-left">
                  Didn’t receive the code?
                </div>

                <div
                  className={`upi-otp-footer-right ${
                    resendSeconds === 0 ? "upi-otp-resend-active" : ""
                  }`}
                  onClick={resendSeconds === 0 ? handleResendOtp : undefined}
                  role="button"
                  tabIndex={0}
                >
                  {resendSeconds > 0
                    ? `Resend in ${formatTime(resendSeconds)}`
                    : "Resend now"}
                </div>
              </div>
            </div>

            <div className="upi-forget-popup-action">
              <GloablButton
                width="250px"
                height="44px"
                backgroundColor="#4072C8"
                text="Continue"
                borderRadius="50px"
                onClick={handleVerifyOtpContinue}
              />
            </div>
          </div>
        </div>
      )}

      {openOtpDonePopup && (
        <div className="upi-popup-overlay" onClick={closeOtpDonePopup}>
          <div className="upi-done-popup" onClick={(e) => e.stopPropagation()}>
            <div className="close-icon" onClick={closeOtpDonePopup}>
              <CloseIcon />
            </div>

            <div className="upi-forget-popup-picture">
              <AzaleaLogo />
            </div>

            <div className="upi-forget-popup-section">
              <div className="upi-forget-popup-title">
                Company Selection + Birthdate
              </div>
              <div className="upi-done-popup-paragraphe">
                Securely confirm which company account the user is requesting
                UPI for.
              </div>
            </div>

            <div className="company-birthdate-card">
              {/* Company */}
              <div className="form-group">
                <label className="form-label">
                  Company Name <span className="required">*</span>
                </label>

                <select
                  className="form-select"
                  value={selectedCompany}
                  onChange={(e) => setSelectedCompany(e.target.value)}
                  disabled={companiesLoading}
                >
                  <option value="">
                    {companiesLoading ? "Loading..." : "Select company"}
                  </option>

                  {companies.map((c, idx) => {
                    const value =
                      c?.userCompanyID ??
                      c?.userCompanyId ??
                      c?.companyID ??
                      c?.companyId ??
                      c?.id ??
                      c?.value;

                    const label =
                      c?.companyName ??
                      c?.name ??
                      c?.label ??
                      `Company ${idx + 1}`;

                    if (value == null) return null;

                    return (
                      <option key={String(value)} value={String(value)}>
                        {label}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* Birthdate */}
              <div className="form-group">
                <label className="form-label">
                  Birthdate <span className="required">*</span>
                </label>

                <div className="date-input-wrapper">
                  {/* <input
                    type="date"
                    className="form-input"
                    value={birthdate}
                    onChange={(e) => setBirthdate(e.target.value)}
                  /> */}
                  <SingleDatePicker
                    value={birthdate || ""}
                    onChange={setBirthdate}
                    // onChange={(value) => setBirthdate(value)}
                    className="birthday-date-picker"
                  />
                  <span className="calendar-icon" />
                </div>
              </div>
            </div>

            <div className="upi-forget-popup-action">
              <GloablButton
                width="250px"
                height="44px"
                backgroundColor="#4072C8"
                text="Continue"
                borderRadius="50px"
                onClick={handleOtpDoneContinue}
              />
            </div>
          </div>
        </div>
      )}

      {openUpiRecoveredPopup && (
        <div className="upi-popup-overlay" onClick={closeUpiRecoveredPopup}>
          <div
            className="upi-success-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="upi-success-icon-wrap">
              <div className="upi-success-check">
                <DoneIcone />
              </div>
            </div>

            <div className="upi-success-title">UPI Recovered Successfully</div>
            <div className="upi-success-subtitle">
              All good. Check your email for your UPI.
            </div>

            <div className="upi-success-action">
              <GloablButton
                width="180px"
                height="44px"
                backgroundColor="#4072C8"
                text="Back to login"
                borderRadius="50px"
                onClick={handleBackToLogin}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SignInInput;
